module.exports = __webpack_public_path__ + "static/media/1029623.a1f74633.jpg";